function cov_16et27h6cc() {
  var path = "/app/src/components/non-standart-learn-more/non-standart-learn-more.tsx";
  var hash = "5011f20c9e68d6cd12eb4270384c8f427dd9d2ab";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/non-standart-learn-more/non-standart-learn-more.tsx",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 36
        },
        end: {
          line: 63,
          column: 1
        }
      },
      "1": {
        start: {
          line: 19,
          column: 39
        },
        end: {
          line: 19,
          column: 54
        }
      },
      "2": {
        start: {
          line: 20,
          column: 12
        },
        end: {
          line: 20,
          column: 23
        }
      },
      "3": {
        start: {
          line: 21,
          column: 18
        },
        end: {
          line: 21,
          column: 51
        }
      },
      "4": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 62,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 18,
            column: 36
          },
          end: {
            line: 18,
            column: 37
          }
        },
        loc: {
          start: {
            line: 18,
            column: 72
          },
          end: {
            line: 63,
            column: 1
          }
        },
        line: 18
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 33,
            column: 7
          },
          end: {
            line: 46,
            column: 7
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 39,
            column: 10
          }
        }, {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 45,
            column: 10
          }
        }],
        line: 33
      },
      "1": {
        loc: {
          start: {
            line: 54,
            column: 7
          },
          end: {
            line: 58,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 7
          },
          end: {
            line: 54,
            column: 19
          }
        }, {
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 57,
            column: 17
          }
        }],
        line: 54
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5011f20c9e68d6cd12eb4270384c8f427dd9d2ab"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_16et27h6cc = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_16et27h6cc();
import React from 'react';
import { CreditCards } from 'src/components/credit-cards';
import { LearnMoreHowItWorks } from 'src/components/learn-more-how-it-works';
import { TrustBanner } from 'src/components/trust-banner';
import { Button } from 'src/components/v2/button';
import { COUNTRY_BY_CURRENCY_MAP } from 'src/constants/country-by-currency-map';
import { useAppContext } from 'src/context/store/app-provider';
import { useLocale } from 'src/hooks/use-locale';
import { PopupLearnMoreBackgroundHeader } from '../popup-learn-more-background-header';
import styles from './styles.css';
cov_16et27h6cc().s[0]++;
export var NonStandartLearnMore = function NonStandartLearnMore(_ref) {
  var onClose = _ref.onClose,
    onContinue = _ref.onContinue;
  cov_16et27h6cc().f[0]++;
  var _ref2 = (cov_16et27h6cc().s[1]++, useAppContext()),
    currency = _ref2.currency,
    partnerCharges = _ref2.partnerCharges;
  var t = (cov_16et27h6cc().s[2]++, useLocale());
  var country = (cov_16et27h6cc().s[3]++, COUNTRY_BY_CURRENCY_MAP[currency]);
  cov_16et27h6cc().s[4]++;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PopupLearnMoreBackgroundHeader, {
    onClose: onClose,
    title: t('pay_in_interest_free_payments'),
    subtitle: t('split_your_purchase_and_pay_over_time')
  }), /*#__PURE__*/React.createElement(LearnMoreHowItWorks, {
    partnerCharges: partnerCharges
  }), country === 'KSA' ? (cov_16et27h6cc().b[0][0]++, /*#__PURE__*/React.createElement(TrustBanner, {
    title: t('shariah_compliant_payments'),
    description: t('our_payment_options_meet_islamic_finance_standards'),
    icon: "shariat-modern",
    iconClassName: styles.bannerIcon
  })) : (cov_16et27h6cc().b[0][1]++, /*#__PURE__*/React.createElement(TrustBanner, {
    title: t('tabby_trusted.trusted_by_milions'),
    description: t('over_20_million_shoppers_pay_with_tabby'),
    icon: "people"
  })), /*#__PURE__*/React.createElement(TrustBanner, {
    title: t('tabby_care.show_safely'),
    description: t('tabby_care.buyer_protection_included'),
    icon: "tabby-care"
  }), (cov_16et27h6cc().b[1][0]++, !!onContinue) && (cov_16et27h6cc().b[1][1]++, /*#__PURE__*/React.createElement(Button, {
    onClick: onContinue,
    testAttr: "continue-shopping"
  }, t('tabbySplit.continue_shopping'))), /*#__PURE__*/React.createElement(CreditCards, {
    country: country,
    fullWidth: true
  }));
};